import React from 'react';
import { css } from '@emotion/core';
import { theme } from '@weave/theme-original';
import { StatusBanner } from 'components/shared';
import { ReactComponent as StatusErrorIcon } from 'images/status-error.svg';
import { ReactComponent as RefreshIcon } from 'images/refresh-icon.svg';
import { NakedButton, Text } from '@weave/design-system';

interface BlockedStatusBannerProps {
  blockedCount: number;
  blockedMetricNames: string[];
  onRefresh: () => void;
}

export const BlockedStatusBanner = ({
  blockedCount,
  blockedMetricNames,
  onRefresh,
}: BlockedStatusBannerProps) => {
  return (
    <StatusBanner
      variant="blocked"
      icon={<StatusErrorIcon />}
      title={`${blockedCount} Blocked ${
        blockedCount === 1 ? 'Item Requires' : 'Items Require'
      } Your Attention`}
      description={blockedMetricNames}
      action={
        <NakedButton css={ctaButton} onClick={onRefresh}>
          <RefreshIcon />
          <Text as="span" weight="bold" size="medium">
            Refresh
          </Text>
        </NakedButton>
      }
    />
  );
};

const ctaButton = css`
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.medium};
  padding: ${theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${theme.spacing(1)};

  > span {
    color: #146ef5;
  }
`;
